<template>
    <div>
        <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center row">
                                <div class="col-sm-1 col-md-1">
                                    <select style="width:60px !important" class="form-control mb-1" v-model="tableData.length" @change="changePerPage()">
                                        <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                                    </select>
                                </div>
                                <div id="search_zone" class="mb-2 mr-1 text-right">

                                </div>
                            </div>
                            <v-table :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
                                <tbody>
                                    <tr class="pointer" v-for="(user, key) in users" :key="key">
                                        <td>{{ user.name }}</td>
                                        <td>{{ user.product.name }}</td>
                                        <td>{{ $format(user.amount) }}</td>
                                        <td>{{ user.created_at }}</td>
                                    </tr>
                                </tbody>
                            </v-table>
                            <v-paginate :pagination="pagination"
                                @prev="getPrev(pagination.prevPageUrl)"
                                @next="getNext(pagination.nextPageUrl)">
                            </v-paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {api, _buildQuery } from "../../../helpers/shared";
import vTable from '../../../components/vTable/vTable.vue';
import vPaginate from '../../../components/vTable/vPaginate.vue';
import axios from 'axios';
export default {
    components:{
        vTable, vPaginate
    },
    data() {
        let sortOrders = {};
        let columns = [
            {width: '33%', label: 'Client', name: 'first_name' },
            {width: '33%', label: 'Produit', name: 'email'},
            {width: '33%', label: 'Montant', name: 'profile'},
            {width: '33%', label: 'Date', name: 'status'}
        ];
        columns.forEach((column) => {
            sortOrders[column.name] = -1;
        });
        return {
            users: [],
            columns: columns,
            sortKey: 'customer',
            sortOrders: sortOrders,
            perPage: ['10', '20', '30'],
            tableData: {
                page: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
                profile: '',
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: ''
            },
            loading: false,
            index: null,
        }
    },

    mounted(){
        this.getUsers();
    },
    methods:{
        changePerPage(url = 'administration/wait-for-confirmation'){
            this.tableData.page = 1;
            axios.get(api(url), {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.users = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getNext(url){
            this.tableData.page ++;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.users = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getPrev(url){
            this.tableData.page --;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.users = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getUsers(url = 'administration/wait-for-confirmation') {
            this.tableData.page++;
            axios.get(api(url), {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.users = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
        },
        configPagination(data) {
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
            this.getUsers();
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        }
    }
}
</script>

<style lang="sss" scoped>

</style>
